// Source : web/wp-content/themes/studiometa/src/js/components/Fade.js
// Enregistré dans app.js via : '[data-fade]': Fade

import { Base, withIntersectionObserver, useResize } from '@studiometa/js-toolkit';

const DESKTOP_BREAKPOINTS = new Set(['l', 'xl', '2xl', '3xl']);

/**
 * Homepage class.
 */
export default class Fade extends withIntersectionObserver(Base, {
  threshold: 0.3,
}) {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Fade',
    options: {
      delay: {
        type: Number,
        default: 0.2,
      },
      // Délais responsive optionnels (-1 = non défini, on retombe sur `delay`).
      delayMobile: {
        type: Number,
        default: -1,
      },
      delayDesktop: {
        type: Number,
        default: -1,
      },
    },
  };

  isDesktop = false;

  /**
   *
   */
  mounted() {
    this.isDesktop = DESKTOP_BREAKPOINTS.has(useResize().props().breakpoint);
  }

  /**
   * Auto-bound by the `resized` service.
   * @param {{ breakpoint: string }} payload
   */
  resized({ breakpoint }) {
    this.isDesktop = DESKTOP_BREAKPOINTS.has(breakpoint);
  }

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      this.launchAnimation();
    }
  }

  /**
   * Renvoie la valeur de délai brute en tenant compte des variantes responsive.
   * @returns {number}
   */
  get rawDelay() {
    const responsive = this.isDesktop ? this.$options.delayDesktop : this.$options.delayMobile;
    return responsive >= 0 ? responsive : this.$options.delay;
  }

  /**
   *
   */
  launchAnimation() {
    const raw = this.rawDelay;
    const delay = raw === 0.2 ? raw : Number(raw) / 8;
    this.$el.style.transitionDelay = `${delay}s`;

    if (this.$el.classList.contains('inview')) {
      return;
    }

    this.$el.classList.add('inview');
  }
}
